import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/what-to-expect-tms-consultation")({
  beforeLoad: () => {
    throw redirect({ to: "/what-to-expect-from-your-consultation" });
  },
});
